export const BETA_TOUR_SEEN_KEY = 'teamf-824-beta-tour-seen';

export interface BetaTourStep {
  id: string;
  anchorSelector: string;
  title: string;
  body: string;
}

export const betaTourSteps = (isAdmin: boolean): readonly BetaTourStep[] => [
  {
    id: 'pages',
    anchorSelector: '.nc_side-nav__items',
    title: 'All your pages, in one list',
    body: 'Same pages as before, grouped into sections you can see at a glance. The menu stays open as you work.',
  },
  {
    id: 'scope',
    anchorSelector: '.nc_side-nav__filter',
    title: isAdmin ? 'Pick a site once' : 'Pick a class once',
    body: 'Your choice follows you from page to page, so you don’t have to select it again on each one.',
  },
  {
    id: 'menu',
    anchorSelector: '.nc_beta-chip',
    title: 'Your beta menu',
    body: 'Replay this tour, send us feedback, or switch back to the old navigation at any time. You’re helping shape what comes next.',
  },
];

export const getAvailableSteps = (doc: Document, isAdmin: boolean): BetaTourStep[] =>
  betaTourSteps(isAdmin).filter(step => doc.querySelector(step.anchorSelector));

export const hasSeenBetaTour = (): boolean => {
  try {
    return localStorage.getItem(BETA_TOUR_SEEN_KEY) === '1';
  } catch {
    return true;
  }
};

export const markBetaTourSeen = (): void => {
  try {
    localStorage.setItem(BETA_TOUR_SEEN_KEY, '1');
  } catch {
    return;
  }
};
